import { render, staticRenderFns } from "./appointmentInformation.vue?vue&type=template&id=c0b76756&"
import script from "./appointmentInformation.vue?vue&type=script&lang=js&"
export * from "./appointmentInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports